export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtMenaKurz';
export const NAME = 'MenaKurz';
